const {h, render, Component} = require('preact');

class Transaction extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let transaction = this.props.transaction;
    return (
      <div data-bhw="web2018_claim_summary_transaction_link" onClick={(e) => {
        e.preventDefault();
        this.props.goToContactPage(transaction.transactionId)}}>
        <div class="row transaction-row">
          <div class="two columns first-section transaction-date">
            {transaction.spentDate}
          </div>
          <div class="two columns transaction-status">
            {transaction.status}
          </div>
          <div class="two columns description-overflow">
            {transaction.description}
          </div>
          <div class="two columns transaction-date">
            {transaction.cardLinked}
          </div>
          <div class="two columns cashback-earned">
            {transaction.total}
          </div>
          <div class="two columns transaction-cashback">
            {transaction.cashback}
          </div>
        </div>
      </div>

    )
  }
}

module.exports = Transaction
